export interface SettingTankType {
  tankType: string;
  description: string;
  remark: string;
  _id: string;
}

export interface SettingEmissionControlTank {
  emissionControl: string;
  efficiency: number | null;
  remark: string;
  _id: string;
}

export const initTankType = {
  _id: "",
  tankType: "",
  description: "",
  remark: "",
};

export const initTankEmissionControl = {
  _id: "",
  emissionControl: "",
  efficiency: null,
  remark: "",
};

export interface FilterColumns {
  key: string;
  filter: (number | string)[];
}

export interface Filter {
  text: string;
  value: string;
}
